import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#1E3A5F] mb-4">학원소개</h1>
          <p className="text-slate-500 text-lg">대치동 원장직강 FMA수학학원을 소개합니다</p>
        </div>

        {/* About content */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#2563EB]/10 rounded-full px-4 py-1.5 mb-5">
              <i className="ri-award-line text-[#2563EB] text-sm" />
              <span className="text-sm font-medium text-[#2563EB]">FIELDS MATHEMATICS ACADEMY</span>
            </div>
            <h2 className="text-2xl font-bold text-[#1E3A5F] mb-6">
              대치동 <span className="text-[#2563EB]">원장직강</span>,<br />
              20년 정통 수학의 혁신
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              FMA수학학원은 EBS 등 20여년의 강의 경력을 가진 김희삼 원장님이 직접 강의하는 <strong>원장직강 수학학원</strong>입니다. 학생 개별 맞춤식/과외식 수업을 대치동 최고 수준의 교육 전문가가 함께합니다.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              "더 나은, 그 이상의 목표를 위한 수학의 혁신!" — 정통파 수리논술 강사에게 저학년부터 정확하고 제대로 배울 수 있는 환경을 제공합니다. 20년 외길, 대치동이 뒤늦게 쫓아오는 독보적인 개별 맞춤 시스템이 FMA의 자랑입니다.
            </p>
            <div className="flex gap-4 mt-8">
              <a
                href="tel:010-2368-3385"
                className="inline-flex items-center whitespace-nowrap h-11 px-6 bg-[#2563EB] hover:bg-[#1d4ed8] text-white font-medium rounded-lg text-sm transition-colors cursor-pointer gap-2"
              >
                <i className="ri-phone-line" />
                010-2368-3385
              </a>
              <a
                href="https://blog.naver.com/fmasky"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center whitespace-nowrap h-11 px-6 bg-white border border-slate-200 hover:border-[#2563EB] text-slate-600 font-medium rounded-lg text-sm transition-colors cursor-pointer gap-2"
              >
                <i className="ri-global-line" />
                블로그 보기
              </a>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden border border-slate-100">
            <img
              src="https://mgx-backend-cdn.metadl.com/generate/images/1032187/2026-03-16/aee65667-b922-4be5-8f17-56f3e06df1c4.png"
              alt="FMA수학학원 수업 장면"
              className="w-full h-80 object-cover object-top"
            />
          </div>
        </div>

        {/* Director Info */}
        <div className="bg-white rounded-2xl p-8 border border-slate-100 mb-20">
          <h2 className="text-2xl font-bold text-[#1E3A5F] mb-8 text-center">원장 소개</h2>
          <div className="flex flex-col md:flex-row items-center gap-8 mb-10">
            <div className="shrink-0">
              <div className="w-48 h-64 rounded-2xl overflow-hidden border-4 border-[#2563EB]/20">
                <img
                  src="https://static.readdy.ai/image/ac5354a337ef5aec4d3ed5a54041f062/1244bc178b7e8acd74fe6d1f20c1bc84.png"
                  alt="김희삼 원장"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div>
              <div className="flex items-center gap-3 mb-3">
                <h3 className="text-xl font-bold text-[#1E3A5F]">김희삼 원장</h3>
                <span className="text-xs font-medium px-3 py-1 bg-[#2563EB]/10 text-[#2563EB] rounded-full">원장직강</span>
              </div>
              <ul className="space-y-2">
                {[
                  "EBS 등 20여년의 수학 강의 경력",
                  "대치동 원장직강 소수정예 FMA수학학원 운영",
                  "정통파 수리논술 전문 강사",
                  "학생 개별 맞춤식/과외식 수업 설계",
                  "내신·세특·정시 3축 입시 시스템 구축",
                ].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-sm text-slate-600">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-line text-[#2563EB]" />
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* 약력 */}
          <div className="border-t border-slate-100 pt-8">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-1 h-6 bg-[#2563EB] rounded-full" />
              <h3 className="text-lg font-bold text-[#1E3A5F]">김희삼 원장 약력</h3>
            </div>
            <div className="w-full rounded-xl overflow-hidden border border-slate-100">
              <img
                src="https://static.readdy.ai/image/ac5354a337ef5aec4d3ed5a54041f062/96045d5b4ba42834d2c5f6812f5b1dd3.png"
                alt="김희삼 원장 약력"
                className="w-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="mb-20">
          <h2 className="text-2xl font-bold text-[#1E3A5F] mb-8 text-center">FMA수학만의 특장점</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: "ri-user-star-line",
                title: "원장 직강 시스템",
                desc: "수업 질이 흔들리지 않습니다. 어떤 수업이든 원장님이 직접 강의합니다.",
              },
              {
                icon: "ri-focus-3-line",
                title: "개별 맞춤 / 과외식 수업",
                desc: "학생 한 명 한 명의 수준과 목표에 맞춘 진짜 맞춤 수업을 경험하세요.",
              },
              {
                icon: "ri-trophy-line",
                title: "내신·세특·정시 3축 시스템",
                desc: "5등급제 걱정 끝! 진짜 실력+세특+정시, 3축으로 입시를 압도합니다.",
              },
            ].map((f) => (
              <div key={f.title} className="bg-white rounded-2xl p-8 text-center border border-slate-100 hover:-translate-y-1 transition-all duration-300">
                <div className="w-16 h-16 bg-[#2563EB]/10 rounded-2xl flex items-center justify-center mx-auto mb-5">
                  <i className={`${f.icon} text-2xl text-[#2563EB]`} />
                </div>
                <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">{f.title}</h3>
                <p className="text-slate-500 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Education Philosophy */}
        <div className="bg-gradient-to-r from-[#1E3A5F] to-[#2563EB] rounded-3xl p-10 text-white text-center">
          <h2 className="text-2xl font-bold mb-4">교육 철학</h2>
          <p className="text-slate-200 max-w-2xl mx-auto leading-relaxed text-lg">
            "더 나은, 그 이상의 목표를 위한 수학의 혁신!"
          </p>
          <p className="text-slate-300 max-w-2xl mx-auto leading-relaxed mt-4">
            20년 외길, 대치동이 뒤늦게 쫓아오는 FMA수학의 독보적인 개별 맞춤 시스템.<br />
            수포자도 수학 우등생으로 만드는 원장직강 시스템을 경험해보세요.
          </p>
          <a
            href="tel:010-2368-3385"
            className="mt-8 inline-flex items-center justify-center whitespace-nowrap h-11 px-8 bg-[#F59E0B] hover:bg-[#D97706] text-[#1E3A5F] font-bold rounded-lg text-sm transition-colors cursor-pointer gap-2"
          >
            <i className="ri-phone-line" />
            010-2368-3385 상담하기
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}
